import { FigureTwicpics } from '@studiometa/ui';

export default class Figure extends FigureTwicpics {
  get domain() {
    return 'cdn.studiometa.fr';
  }

  get path() {
    return 'artflo';
  }
}
